export default __webpack_public_path__ + "static/media/003-anchor.6ff75ce2.svg";